import React, { useEffect, useState, useRef } from 'react';
import HTMLReactParser from 'html-react-parser';
import milaCircle from 'assets/images/mila-circle.png';
import bigsneezeCircle from 'assets/images/bigsneeze-circle.png';
import crittercuddlerCircle from 'assets/images/crittercuddler-circle.png';
import basicbreatherCircle from 'assets/images/basicbreather-circle.png';
import rookieparentsCircle from 'assets/images/rookieparents-circle.png';
import homewreckerCircle from 'assets/images/homewrecker-circle.png';
import mamatobeCircle from 'assets/images/mamatobe-circle.png';
import overreactorCircle from 'assets/images/overreactor-circle.png';
import loadable from '@loadable/component';

const LazyImg = loadable(() => import('../common/LazyImg'));

/**
 * @param selectedItem
 * @param setSelectedItem
 * @param selectedItemHTML
 * @param setSelectedItemHTML
 * @param filterScrollTop
 * @param topOffset
 * @param reviewBlockRef
 * @returns {JSX.Element}
 * @constructor
 */

const ReviewsMobileFilter = ({
  selectedItem,
  setSelectedItem,
  selectedItemHTML,
  setSelectedItemHTML,
  topOffset,
  filterScrollTop,
  reviewBlockRef,
}) => {
  const [ isFilterOpen, setIsFilterOpen ] = useState(false);
  const [ isFilterNavActive, setIsFilterNavActive ] = useState(false);
  const navRef = useRef(null);

  const filterHandler = e => {
    e.preventDefault();
    const _this = e.currentTarget;
    const getFilterAttr = _this.getAttribute('data-filter');
    setSelectedItem(getFilterAttr === 'all' ? '' : [ getFilterAttr ]);
    setSelectedItemHTML(_this.innerHTML);
    filterScrollTop();
  };

  useEffect(() => {
    function filterMobileNavSticky() {
      const reviewBlockOffsetTop = reviewBlockRef.current.offsetTop;
      const windowScrollTop = document.documentElement.scrollTop;
      if (windowScrollTop > ((reviewBlockOffsetTop - 118) - (navRef.current.scrollHeight))) {
        setIsFilterNavActive(true);
        reviewBlockRef.current.style.paddingTop = `${navRef.current.scrollHeight}px`;
        navRef.current.style.top = `${topOffset}px`;
      } else {
        setIsFilterNavActive(false);
        navRef.current.style.top = 0;
        reviewBlockRef.current.style.paddingTop = 0;
      }
    }

    document.addEventListener('DOMContentLoaded', filterMobileNavSticky);
    window.addEventListener('resize', filterMobileNavSticky);
    window.addEventListener('scroll', filterMobileNavSticky);

    return () => {
      document.removeEventListener('DOMContentLoaded', filterMobileNavSticky);
      window.removeEventListener('resize', filterMobileNavSticky);
      window.removeEventListener('scroll', filterMobileNavSticky);
    };
  }, [ selectedItem ]);

  return (
    <div className={`filter-items__mobile-nav ${isFilterNavActive ? 'fixed' : ''}`} ref={navRef}>
      <button
        type='button'
        className={`filter-items__toggle ${isFilterOpen ? 'active' : ''}`}
        onClick={() => setIsFilterOpen(!isFilterOpen)}
      >
        <span className='filter-option__active-tab'>
          {
            HTMLReactParser(selectedItemHTML)
          }
        </span>
        <svg className='icon icon-arrow-dropdown'>
          <use xlinkHref='#icon-arrow-dropdown' />
        </svg>
      </button>
      <div className={`filter-items__mobile ${isFilterOpen ? 'active' : ''}`}>
        <button
          type='button'
          className={`filter-items__mobile-item showAll ${!selectedItem.includes('all') && selectedItem.length > 0 ? 'show-filter' : ''}`}
          data-filter='all'
          onClick={e => filterHandler(e)}
        >
          <figure className='filter-items__mobile-icon'>
            <LazyImg src={milaCircle} alt='mila circle' />
          </figure>
          <strong>Show All</strong>
        </button>
        <button
          type='button'
          className={`filter-items__mobile-item filter-items__mobile-item--big-sneeze ${selectedItem.includes('big-sneeze') ? 'selected-item' : ''}`}
          data-filter='big-sneeze'
          onClick={e => filterHandler(e)}
        >
          <figure className='filter-items__mobile-icon'>
            <LazyImg src={bigsneezeCircle} alt='sneezing-face' />
          </figure>
          <strong>Big Sneeze</strong>
        </button>
        <button
          type='button'
          className={`filter-items__mobile-item filter-items__mobile-item--critter-cuddler ${selectedItem.includes('critter-cuddler') ? 'selected-item' : ''}`}
          data-filter='critter-cuddler'
          onClick={e => filterHandler(e)}
        >
          <figure className='filter-items__mobile-icon'>
            <LazyImg src={crittercuddlerCircle} alt='dog-face' />
          </figure>
          <strong>Critter Cuddler</strong>
        </button>
        <button
          type='button'
          className={`filter-items__mobile-item filter-items__mobile-item--basic-breather ${selectedItem.includes('basic-breather') ? 'selected-item' : ''}`}
          data-filter='basic-breather'
          onClick={e => filterHandler(e)}
        >
          <figure className='filter-items__mobile-icon'>
            <LazyImg src={basicbreatherCircle} alt='leaf-fluttering-in-wind' />
          </figure>
          <strong>Basic Breather</strong>
        </button>
        <button
          type='button'
          className={`filter-items__mobile-item filter-items__mobile-item--rookie-parent ${selectedItem.includes('rookie-parent') ? 'selected-item' : ''}`}
          data-filter='rookie-parent'
          onClick={e => filterHandler(e)}
        >
          <figure className='filter-items__mobile-icon'>
            <LazyImg src={rookieparentsCircle} alt='baby' />
          </figure>
          <strong>Rookie Parent</strong>
        </button>
        <button
          type='button'
          className={`filter-items__mobile-item filter-items__mobile-item--home-wrecker ${selectedItem.includes('home-wrecker') ? 'selected-item' : ''}`}
          data-filter='home-wrecker'
          onClick={e => filterHandler(e)}
        >
          <figure className='filter-items__mobile-icon'>
            <LazyImg src={homewreckerCircle} alt='construction' />
          </figure>
          <strong>Home Wrecker</strong>
        </button>
        <button
          type='button'
          className={`filter-items__mobile-item filter-items__mobile-item--mama-to-be ${selectedItem.includes('mama-to-be') ? 'selected-item' : ''}`}
          data-filter='mama-to-be'
          onClick={e => filterHandler(e)}
        >
          <figure className='filter-items__mobile-icon'>
            <LazyImg src={mamatobeCircle} alt='woman' />
          </figure>
          <strong>Mama-to-be</strong>
        </button>
        <button
          type='button'
          className={`filter-items__mobile-item filter-items__mobile-item--overreactor ${selectedItem.includes('overreactor') ? 'selected-item' : ''}`}
          data-filter='overreactor'
          onClick={e => filterHandler(e)}
        >
          <figure className='filter-items__mobile-icon'>
            <LazyImg src={overreactorCircle} alt='exploding-head' />
          </figure>
          <strong>Overreactor</strong>
        </button>
      </div>
    </div>
  );
};

export default ReviewsMobileFilter;
